import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';
import { useTranslation } from 'react-i18next';

interface TimeCardProps {
  work_time: number | null; // Define the props interface
}

defineElement(lottie.loadAnimation);
const TimeCard: React.FC<TimeCardProps> = ({ work_time }) => {
  const { t } = useTranslation();

  return (
    <div className="card shadow-lg">
      <div className="card-body text-center">
        <h6 className="card-title mb-3 flex-grow-1 text-start fw-bold">{t('MCTDetail.TimeCard.workTime')}</h6>
        <div className="mb-2">
          <lord-icon
            src="https://cdn.lordicon.com/kbtmbyzy.json"
            trigger="loop"
            colors="primary:#405189,secondary:#02a8b5"
            style={{ width: '70px', height: '70px' }}
          />
        </div>
        <h3 className="mb-1">
          {work_time ? work_time : 0} {t('MCTDetail.TimeCard.days')}.
        </h3>
      </div>
    </div>
  );
};

export default TimeCard;
